// extracted by mini-css-extract-plugin
export var ctaArrow = "styles-module--ctaArrow--04271";
export var ctaArrowIcon = "styles-module--ctaArrowIcon--ed054";
export var ctaArrowLine = "styles-module--ctaArrowLine--db70d";